/**
 * Fixes elastic bounce on document if user scrolls while scrollable child div is already scrolled to top/bottom
 * The document won't scroll, since the overflowing child div will always have room to scroll
 * @param: {string}  id of overflowing element, e.g. 'scroller'
 *
 * inspiration from: http://stackoverflow.com/questions/10238084/ios-safari-how-to-disable-overscroll-but-allow-scrollable-divs-to-scroll-norma
 * but those solutions do not seem to work on iPad 2 iOS 9
 * This solution simply checks the scroll event and always keeps 1 pixel to scroll on top and bottom
 * Only triggers on touchstart, on first touch it might not work because the device is too slow
 */
export const enableElasticBounce = function(el) {

    const adjustScroll = function() {

        if (el.scrollTop === 0) {
            el.scrollTop = 1;
        } else if (el.scrollHeight === el.scrollTop + el.offsetHeight) {
            el.scrollTop -= 1;
        }

    }

    const starter = function() {

        if ( !el || scrollables.indexOf(el) != -1 ) {
            return // already enabled
        }

        adjustScroll()
        el.addEventListener('scroll', adjustScroll)
        window.removeEventListener('touchstart', starter)

    }

    if ( detectedTouch() ) {
        starter()
    } else {
        window.addEventListener('touchstart', starter)
    }

}

export const disableElasticBounce = function(el) {
    const idx = scrollables.indexOf(el)
    if ( idx !== -1 ) {
        scrollables.splice(idx, 1)
    }
}

export const vueScrollDirective = {
    inserted: function (el) {
        enableElasticBounce(el)
    },

    unbind: function(el) {
        disableElasticBounce(el)
    }
}

let scrollables = []

function detectedTouch() {
    return ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/scroll.js